<av-content-container>
    <div class="col-6 mb-4">
        <av-card cardTitle="app.device.overview.sections.hardware.title" icon="memory" [fields]="hardwareFields()" />
    </div>

    <div class="col-6 mb-4">
        <av-card cardTitle="app.device.overview.sections.owner.title" icon="person" [fields]="ownerFields()" />
    </div>

    <div class="col-6">
        <av-card cardTitle="app.device.overview.sections.os.title" icon="computer" [fields]="osFields()" />
    </div>

    <div class="col-6">
        <av-card cardTitle="app.device.overview.sections.entra.title" icon="verified_user" [fields]="entraFields()" />
    </div>
</av-content-container>